export const summaryFileTemplateTypes = [
	"property_deal_billing_owner",
	"property_deal_billing_rentee",
	"deal_billing_owner",
	"deal_billing_rentee",
	"deal_settlement_owner",
	"deal_settlement_rentee",
	"deal_receipt"
] as const;
export type SummaryFileTemplateType = (typeof summaryFileTemplateTypes)[number];
export type SummaryFileTemplate = {
	fileName: string;
	id: number;
	templateType: SummaryFileTemplateType;
};
const SECTION = {
	deal: "案件",
	property_deal: "案件グループ"
} as const;

const ADDRESS = {
	none: "",
	owner: "オーナー",
	rentee: "入居者"
} as const;

const TYPE = {
	billing: "請求書",
	receipt: "発注書請書",
	settlement: "精算書"
} as const;

export const summaryFileTemplateDetails = {
	deal_billing_owner: {
		address: ADDRESS.owner,
		section: SECTION.deal,
		type: TYPE.billing
	},
	deal_billing_rentee: {
		address: ADDRESS.rentee,
		section: SECTION.deal,
		type: TYPE.billing
	},
	deal_receipt: {
		address: ADDRESS.none,
		section: SECTION.deal,
		type: TYPE.receipt
	},
	deal_settlement_owner: {
		address: ADDRESS.owner,
		section: SECTION.deal,
		type: TYPE.settlement
	},
	deal_settlement_rentee: {
		address: ADDRESS.rentee,
		section: SECTION.deal,
		type: TYPE.settlement
	},
	property_deal_billing_owner: {
		address: ADDRESS.owner,
		section: SECTION.property_deal,
		type: TYPE.billing
	},
	property_deal_billing_rentee: {
		address: ADDRESS.rentee,
		section: SECTION.property_deal,
		type: TYPE.billing
	}
} as const satisfies Record<
	SummaryFileTemplateType,
	{
		address: string;
		section: string;
		type: string;
	}
>;
